/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchAccountRequest} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'
import {SearchAccountResponse} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'


export const searchAccount = (request: SearchAccountRequest, options?: CashRequestOptions) => post<SearchAccountRequest, SearchAccountResponse>("/cash-app/local/search-account", request, {...options, rejectOnError: true })